// extracted by mini-css-extract-plugin
export default {"teamTable":"d7f3f2693a16"};